import { render, staticRenderFns } from "./willExpire.vue?vue&type=template&id=a8ee0bf2&scoped=true&"
import script from "./willExpire.vue?vue&type=script&lang=js&"
export * from "./willExpire.vue?vue&type=script&lang=js&"
import style0 from "./willExpire.vue?vue&type=style&index=0&id=a8ee0bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ee0bf2",
  null
  
)

export default component.exports